import { SHIFT_SECTIONS, APP_VIEWS } from '../../../stores';
import {
    SettingsIcon, TeamsIcon, EventsIcon, GamesIcon, BroadcastIcon,
    OrgIcon, CampIcon
} from './icons';

// Типы игр — совпадают с ключами GAME_TABS_CONFIG / GameType бэкенда.
export const GAME_TYPES = Object.freeze({
    DEMOCRACY: 'DEMOCRACY',
    KILLER: 'KILLER',
    BET: 'BET',
    FAIR: 'FAIR',
    LEGEND: 'LEGEND',
    NEIGHBOR: 'NEIGHBOR',
    DOZOR: 'DOZOR',
    TEAM_TASK: 'TEAM_TASK'
});

// Разделы смены (sidebar .side-nav). section === значение SHIFT_SECTIONS.
// Раздел "Игры" разворачивает под-список игр (.side-sub).
export const SIDEBAR_SECTIONS = Object.freeze([
    { section: SHIFT_SECTIONS.SETTINGS, label: 'Смена', Icon: SettingsIcon },
    { section: SHIFT_SECTIONS.TEAMS, label: 'Команды', Icon: TeamsIcon },
    { section: SHIFT_SECTIONS.EVENTS, label: 'Мероприятия', Icon: EventsIcon },
    { section: SHIFT_SECTIONS.GAMES, label: 'Игры', Icon: GamesIcon, hasGames: true },
    { section: SHIFT_SECTIONS.BROADCAST, label: 'Рассылки', Icon: BroadcastIcon }
]);

// Игры (sidebar .side-sub). Реальный список фильтруется по активным играм смены.
export const SIDEBAR_GAMES = Object.freeze([
    { type: GAME_TYPES.DEMOCRACY, label: 'Демократия' },
    { type: GAME_TYPES.KILLER, label: 'Киллер' },
    { type: GAME_TYPES.BET, label: 'Ставки' },
    { type: GAME_TYPES.FAIR, label: 'Ярмарка' },
    { type: GAME_TYPES.LEGEND, label: 'Легенды' },
    { type: GAME_TYPES.NEIGHBOR, label: 'Насоли соседу' },
    { type: GAME_TYPES.DOZOR, label: 'Дозор' },
    { type: GAME_TYPES.TEAM_TASK, label: 'Командные задания' }
]);

// Футер sidebar (.side-foot) — глобальные view. view === значение APP_VIEWS.
export const SIDEBAR_FOOTER = Object.freeze([
    { view: APP_VIEWS.ORGANIZERS, label: 'Организаторы', Icon: OrgIcon },
    { view: APP_VIEWS.CAMP_SETTINGS, label: 'Лагерь', Icon: CampIcon }
]);
